import type { FaireProductEntity } from "../../entity_types/product";

export const p_ru4xgw4jpy: FaireProductEntity = {
  token: "p_ru4xgw4jpy",
  type: "product",
  name: "Botanical Berry 50ml Hand Cream",
  brandName: "8 Oak Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/0c7669a0a653ce1e135106168c6651713de3f38c64eae209af7134c6a18034fe.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6b1b790df5ac2915993bdd5938ebbca5b0613605aff3c709223cfbf842ea88e3/1539874951.jpg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
